const styleSheet = {
	ACTIVE_BUTTON_BACKGROUND: '#2A55E5',
	DEFAULT_BUTTON_BACKGROUND: '#c2c2c2',
	ERROR_BOTTOM_BORDER_COLOR: '#ff4343',
	NORMAL_BOTTOM_BORDER_COLOR: 'rgba(0,0,0,0.6)',
	ERROR_BORDER_WIDTH: '0px 0px 2px 0px',
	NORMAL_BORDER_WIDTH: '0px 0px 1px 0px',
	WHITE_COLOR: '#ffffff',
	GREY_COLOR: '#878787'
};

export default styleSheet;
